__turbopack_context__.v({
  "accordionSlideOverwrite": "resourceHero-module-scss-module__WIsKka__accordionSlideOverwrite",
  "content": "resourceHero-module-scss-module__WIsKka__content",
  "fadeIn": "resourceHero-module-scss-module__WIsKka__fadeIn",
  "fadeOut": "resourceHero-module-scss-module__WIsKka__fadeOut",
  "featured": "resourceHero-module-scss-module__WIsKka__featured",
  "resourceHero": "resourceHero-module-scss-module__WIsKka__resourceHero",
  "scaleIn": "resourceHero-module-scss-module__WIsKka__scaleIn",
  "scaleOut": "resourceHero-module-scss-module__WIsKka__scaleOut",
  "smallCards": "resourceHero-module-scss-module__WIsKka__smallCards",
  "zoomIn": "resourceHero-module-scss-module__WIsKka__zoomIn",
  "zoomOut": "resourceHero-module-scss-module__WIsKka__zoomOut",
});
